import React from "react";

const ListBox = (props) => {

    return (
        <button className={ "flex w-full py-[10px] px-1 hover:bg-[#F6F6F9]" } key={ props.list?._id }
                onClick={ () => props.handleChooseList() }
        >
            <li
                key={ props.list?._id }
                className="flex items-center"
            >
                <input
                    type="checkbox"
                    checked={ props.chosenLists?.find((item) => item._id === props.list?._id) }
                    className={ "CustomCheckbox" }
                />
                <div className={ "flex items-center gap-[6px]" }>
                    <img alt={ "Logo" } src={ "/media/icons/rows.svg" } className={ "w-4 h-4" }/>
                    <div className={ "NewScheduleListTypeBox" } style={{backgroundColor: props.chosenLists?.find((item) => item._id === props.list?._id) ? "#7E50EA" : "#8185A8"}}>{ props.list?.type }</div>
                    <div className={ "NewScheduleListName" } style={{color: props.chosenLists?.find((item) => item._id === props.list?._id) ? "#7E50EA" : "#15151F"}}>{ props.list?.name }</div>
                </div>
            </li>
        </button>
    );
};

export default ListBox;
